import React from 'react';
import PropTypes from 'prop-types';

import { MARKERS_COUNT_LIMIT } from '../../../constants';

const ZoomMsg = ({
  isDrawing,
  totalResults,
  totalListResults,
  device,
}) => {
  if (!isDrawing && (totalResults > MARKERS_COUNT_LIMIT || (totalResults === 0 && totalListResults === 0 && device !== 'smartphone'))) {
    return (
      <div className="csa_mapsearch__bod__map__tilemsg">
        {(totalResults === 0 && totalListResults === 0) ? 'Non ci sono immobili che corrispondono ai tuoi criteri in questa zona.' : 'Fai zoom per interagire con gli immobili'}
      </div>
    );
  }
  return null;
};

export default ZoomMsg;

ZoomMsg.propTypes = {
  isDrawing: PropTypes.bool,
  totalResults: PropTypes.number,
  totalListResults: PropTypes.number,
  device: PropTypes.string,
};

ZoomMsg.defaultProps = {
  isDrawing: false,
  totalResults: 0,
  totalListResults: 0,
  device: '',
};
